import cls from 'classnames';

import { ImageWithText } from '../ImageWithText';

import useStyles from './styles';
import ImageWithTextListProps from './types';

function ImageWithTextList({ items, inverse, className }: ImageWithTextListProps) {
  const classes = useStyles();

  return (
    <ul className={cls(classes.root, className)}>
      {items.map((item, i) => (
        <li key={`iwt-${i}`}>
          <ImageWithText {...item} imageRight={inverse ? i % 2 === 0 : i % 2 > 0} />
        </li>
      ))}
    </ul>
  );
}

export default ImageWithTextList;
